<div class="wrapper" [class.reverse]="reverse()">
  <div [style]="weaponStyle()" class="weapon"></div>
</div>
